import React, { FunctionComponent } from 'react';
import { Totaliser } from '@justgiving/totaliser';
import { Trans, useTranslation } from 'react-i18next';
import parseCurrency from '../../utils/parseCurrency';
import raisedPercentage from '../../utils/raisedPercentage';
import classNames from 'classnames';

type MemberTotalsProps = {
  targetAmount: number;
  raisedAmount: number;
  currencyCode: string;
};

const MemberTotals: FunctionComponent<MemberTotalsProps> = ({
  targetAmount,
  raisedAmount,
  currencyCode,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });
  const percentage = raisedPercentage(targetAmount, raisedAmount);
  return (
    <>
      {targetAmount > 0 && (
        <div
          className="jg-pages-memberdetails-totaliser"
          data-qa="member-totaliser"
        >
          <Totaliser size="small" percent={percentage} />
        </div>
      )}

      <div
        className={classNames(
          'jg-pages-memberdetails-totals',
          'jg-space-mbsm jg-space-mbn@xl',
        )}
        data-qa="member-total"
      >
        <div className={classNames('jg-text--brand', 'jg-text-color-branded')}>
          {parseCurrency(currencyCode, raisedAmount / 100)}
        </div>

        {targetAmount > 0 ? (
          <Trans i18nKey="members.raisedOfTarget">
            raised of{' '}
            <strong>
              {{
                targetAmount: parseCurrency(currencyCode, targetAmount / 100),
              }}{' '}
              target
            </strong>
          </Trans>
        ) : (
          t('members.raisedNoTarget')
        )}
      </div>
    </>
  );
};

export default MemberTotals;
